import apiClient from '../api/apiClient';

const BASE = '/api/v1/admin/partner-network';

const partnerNetworkService = {
  async assignRm(partnerId, rmId) {
    const response = await apiClient.post(`${BASE}/assign-rm`, {
      partner_id: partnerId,
      rm_id: rmId,
    });
    return response.data;
  },

  async getRmForPartner(partnerId) {
    const response = await apiClient.get(`${BASE}/partner/${partnerId}/rm`);
    return response.data;
  },

  async getPartnersByRm(rmId) {
    const response = await apiClient.get(`${BASE}/rm/${rmId}/partners`);
    const body = response.data;
    if (body?.data && Array.isArray(body.data)) return body.data;
    if (Array.isArray(body)) return body;
    return [];
  },

  async bulkReassignPartners(fromRmId, toRmId) {
    const response = await apiClient.post(`${BASE}/rm/${fromRmId}/reassign-partners`, {
      to_rm_id: toRmId,
    });
    return response.data;
  },

  async getEligibleRms() {
    const response = await apiClient.get(`${BASE}/eligible-rms`);
    const body = response.data;
    const data = body?.data ?? body;
    if (Array.isArray(data?.rms)) return data.rms;
    if (Array.isArray(data)) return data;
    if (Array.isArray(body)) return body;
    return [];
  },
};

export default partnerNetworkService;
